<template>
  <div class="hidden">
    <div class="wrapper">
      <div class="grid">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="item in list"
          :key="item.id"
          class="grid__item news"
        >
          <div class="news__content">
            <div class="news__img">
              <div class="news__category">
                {{ item.sub_category.name }}
              </div>
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="news__title">
              <h3 class="limited-text">{{ item.title }}</h3>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "FourthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$green: #447562;
$bg-white: #f4fffb;
$text-on-bg: #121212;
$color-on-bg-data: #939393;

$offset: 2rem;
.hidden {
  width: 100%;
  @media screen and (max-width: 767px) {
    overflow: hidden;
    max-width: 100%;
  }
}
.wrapper {
  max-width: 95%;
  margin: 0 auto;
  padding: 5rem 0;
  @media screen and (max-width: 767px) {
    padding: 1rem 0;
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  row-gap: 2rem;

  @media screen and (max-width: 767px) {
    row-gap: 1rem;
    position: relative;
    padding: 1rem 0;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 50%;
      transform: translateX(-11%);
      background-color: $bg-white;
      z-index: 0;
    }
  }
  &__item {
    z-index: 1;
    .news {
      &__content {
        display: flex;
        align-items: center;
        @media screen and (max-width: 375px) {
          align-items: left;
        }
      }
      &__img {
        flex: 0 0 38.5%;
        // max-width: 290px;
        // height: 218px;
        position: relative;
        .img {
          padding-bottom: 75%;
        }
      }
      &__category {
        position: absolute;
        z-index: 1;
        background-color: $green;
      }
    }
  }
  &__item:nth-child(1) {
    grid-column: 1 / span 9;
    position: relative;
    @media screen and (max-width: 767px) {
      grid-row: 1 / span 2;
      grid-column: 1 / span 7;
      align-self: center;
    }
    .news {
      &__content {
        margin-right: $offset;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          margin: 0;
        }
        @media screen and (max-width: 767px) {
          align-items: flex-start;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          min-width: 303px;
          min-height: 228px;
        }
        @media screen and (max-width: 767px) {
          min-width: 0;
          min-height: 0;
          .main-image {
            display: none;
          }
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          position: relative;
          text-align: left;
        }
      }
      &__title {
        text-align: left;
        @media screen and (max-width: 992px) {
          text-align: center;
          width: 75%;
        }

        @media screen and (max-width: 767px) {
          text-align: left;
          padding: 0;
          .limited-text {
            --snup: 6;
          }
        }
      }
    }
  }
  &__item:nth-child(1)::before {
    content: "";
    position: absolute;
    bottom: -2rem;
    right: 0rem;
    width: 5px;
    height: 223px;
    z-index: 2;
    background: #fff;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  &__item:nth-child(1)::after {
    content: "";
    position: absolute;
    bottom: -2rem;
    right: 0rem;
    width: 90%;
    height: 5px;
    z-index: 2;
    background: #fff;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  &__item:nth-child(2) {
    grid-column: 10 / span 9;
    position: relative;
    @media screen and (max-width: 767px) {
      grid-column: 8 / span 11;
      grid-row: 1 / span 2;
      color: $text-on-bg;
    }
    .news {
      &__content {
        flex-direction: row-reverse;
        margin-left: $offset;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          margin: 0;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          min-width: 303px;
          min-height: 228px;
        }
        @media screen and (max-width: 767px) {
          max-width: 214px;
          width: 90%;
          height: 142px;
          min-width: auto;
          min-height: 142px;
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          background: $bg-white;
          color: $text-on-bg;
          padding: 0.1rem 0.2rem;
        }
      }
      &__title {
        text-align: right;
        @media screen and (max-width: 992px) {
          text-align: center;
          width: 75%;
        }
        @media screen and (max-width: 375px) {
          text-align: left;
          width: 100%;
        }
      }
    }
  }
  &__item:nth-child(2)::after {
    content: "";
    position: absolute;
    bottom: -2rem;
    left: 0rem;
    width: 90%;
    height: 5px;
    z-index: 2;
    background: #fff;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  &__item:nth-child(3) {
    grid-column: 1 / span 9;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 6;
      margin-top: 0;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 7;
      grid-row: 3 / span 1;
    }
    .news {
      &__content {
        flex-direction: row-reverse;
        @media screen and (max-width: 992px) {
          flex-direction: column;
        }
        @media screen and (max-width: 767px) {
          margin: 0;
          align-items: flex-start;
        }
      }
      &__img {
        margin-right: $offset;
        @media screen and (max-width: 992px) {
          min-width: 215px;
          min-height: 142px;
          margin: 0;
        }
        @media screen and (max-width: 767px) {
          min-width: 0;
          min-height: 0;
          .main-image {
            display: none;
          }
        }
      }

      &__category {
        @media screen and (max-width: 767px) {
          position: relative;
          text-align: left;
        }
      }
      &__title {
        text-align: right;
        @media screen and (max-width: 992px) {
          text-align: left;
          width: 82%;
          margin: 0 auto;
        }

        @media screen and (max-width: 767px) {
          text-align: left;
          padding: 0;
          .limited-text {
            --snup: 6;
          }
        }
      }
    }
  }

  &__item:nth-child(4) {
    grid-column: 10 / span 9;
    margin-top: 2rem;
    @media screen and (max-width: 992px) {
      grid-column: 7 / span 6;
      margin-top: 0;
    }
    @media screen and (max-width: 767px) {
      grid-column: 8 / span 11;
      grid-row: 3 / span 2;
      color: $text-on-bg;
    }
    .news {
      &__content {
        flex-direction: row;
        margin-left: $offset;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          margin: 0;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          margin: 0;

          min-width: 215px;
          min-height: 142px;
          margin: 0;
        }
        @media screen and (max-width: 767px) {
          max-width: 214px;
          width: 90%;

          height: 142px;
          min-width: auto;
          min-height: 142px;
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          background: $bg-white;
          color: $text-on-bg;
          padding: 0.1rem 0.2rem;
        }
      }
      &__title {
        text-align: left;
        @media screen and (max-width: 992px) {
          text-align: left;
          width: 82%;
          margin: 0 auto;
        }
        @media screen and (max-width: 767px) {
          text-align: center;
        }
        @media screen and (max-width: 375px) {
          text-align: left;
          width: 100%;
        }
      }
    }
  }
  &__item:nth-child(5) {
    grid-column: 1 / span 9;
    @media screen and (max-width: 992px) {
      grid-column: 13 / span 6;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 7;
      grid-row: 4 / span 1;
    }
    .news {
      &__content {
        flex-direction: row-reverse;
        @media screen and (max-width: 992px) {
          flex-direction: column;
        }
        @media screen and (max-width: 767px) {
          align-items: flex-start;
        }
      }
      &__img {
        margin-right: $offset;
        @media screen and (max-width: 992px) {
          min-width: 215px;
          min-height: 142px;
          margin: 0;
        }

        @media screen and (max-width: 767px) {
          min-width: 0;
          min-height: 0;
          .main-image {
            display: none;
          }
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          position: relative;
        }
      }
      &__title {
        text-align: right;
        @media screen and (max-width: 992px) {
          text-align: left;
          width: 82%;
          margin: 0 auto;
        }
        @media screen and (max-width: 767px) {
          text-align: left;
          padding: 0;
          .limited-text {
            --snup: 6;
          }
        }
      }
    }
  }
  &__item:nth-child(6) {
    grid-column: 10 / span 9;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 9;
    }
    @media screen and (max-width: 767px) {
      grid-column: 8 / span 11;
      grid-row: 5 / span 2;
      color: $text-on-bg;
    }
    .news {
      &__content {
        margin-left: $offset;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          margin: 0;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          min-width: 303px;
          min-height: 228px;
        }
        @media screen and (max-width: 767px) {
          max-width: 214px;
          width: 90%;
          height: 142px;
          min-width: auto;
          min-height: 142px;
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          background: $bg-white;
          color: $text-on-bg;
          padding: 0.1rem 0.2rem;
        }
      }
      &__title {
        text-align: left;
        @media screen and (max-width: 992px) {
          text-align: center;
          width: 75%;
        }
        @media screen and (max-width: 375px) {
          text-align: left;
          width: 100%;
        }
      }
    }
  }
  &__item:nth-child(7) {
    grid-column: span 18;
    @media screen and (max-width: 992px) {
      grid-column: 10 / span 9;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 7;
      grid-row: 5 / span 2;
      align-self: center;
    }
    .news {
      &__content {
        flex-direction: column;
        align-items: center;
      }
      &__img {
        display: block;
        width: 55%;
        // flex: 1 1 914px;
        // max-width: 914px;
        // min-height: 686px;
        @media screen and (max-width: 992px) {
          width: 100%;
          max-width: 303px;
          min-height: 228px;
        }
        @media screen and (max-width: 767px) {
          min-width: 0;
          min-height: 0;
          .main-image {
            display: none;
          }
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
          position: relative;
        }
      }
      &__title {
        width: 40%;
        text-align: center;
        @media screen and (max-width: 992px) {
          width: 75%;
        }
        @media screen and (max-width: 767px) {
          text-align: left;
          padding: 0;
          .limited-text {
            --snup: 6;
          }
        }
      }
    }
  }
}
.grid__item:nth-child(6),
.grid__item:nth-child(5),
.grid__item:nth-child(7) {
}
.news {
  &__category {
    font-family: Open Sans;
    font-size: 1em;
    line-height: 22px;
    padding: 1px 5px;
    @media screen and (max-width: 992px) {
      font-size: 13px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.7);
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      padding: 0;
      font-size: 10px;
      line-height: 14px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
  &__descr {
    @media screen and (max-width: 992px) {
    }
  }
  &__title {
    font-family: Roboto;
    font-weight: 500;
    font-size: 1.2em;
    line-height: 130%;
    padding: 0 0.5rem;
    margin-top: 0.2rem;
    @media screen and (max-width: 992px) {
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-size: 12px;
      line-height: 15px;
      width: 100% !important;
    }

    .data-news {
      font-family: Open Sans;
      font-size: 0.733em;

      line-height: 19px;
      margin-top: 0.5em;
      @media screen and (max-width: 992px) {
        font-family: Open Sans;
        font-size: 13px;
        line-height: 18px;
      }
      @media screen and (max-width: 767px) {
        font-family: Open Sans;
        font-size: 10px;
        line-height: 14px;
        color: $color-on-bg-data;
      }
    }
  }
  &:nth-child(1),
  &:nth-child(3),
  &:nth-child(5),
  &:nth-child(7) {
    .data-news {
      @media screen and (max-width: 767px) {
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
</style>
